/* metro-ui-components@9.20.0 */
"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
/* eslint-disable */
var React = require("react");
var IconSVG = /** @class */ (function (_super) {
    tslib_1.__extends(IconSVG, _super);
    function IconSVG() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    IconSVG.prototype.render = function () {
        return (React.createElement("svg", tslib_1.__assign({ role: "img", viewBox: "0 0 32 32" }, this.props),
            React.createElement("path", { d: "m27.1356565 9.53129556-11.1356565-4.4542626-11.1356565 4.4542626c.00154042.02270194.00232317.04561178.00232317.06870444v18.6666667c0 .5522847-.44771525 1-1 1s-1-.4477153-1-1v-17.9363004l-.49527599.1981104c-.51278352.2051134-1.09475396-.0443025-1.29986737-.55708602s.0443025-1.09475396.55708601-1.29986737l13.99999998-5.6c.2384111-.09536441.5043703-.09536441.7427814 0l14 5.6c.5127835.20511341.7621994.78708385.557086 1.29986737s-.7870839.76219942-1.2998674.55708602l-.495276-.1981104v17.9363004c0 .5522847-.4477152 1-1 1-.5522847 0-1-.4477153-1-1v-18.6666667c0-.02309266.0007828-.0460025.0023232-.06870444zm-8.8606565 3.46870444h4.725v11h-3.5v-6.9092692l-2.345 6.9092692h-2.2925l-2.3625-6.9092692v6.9092692h-3.5v-11h4.725l2.275 5.5004231z" })));
    };
    return IconSVG;
}(React.Component));
exports.IconSVG = IconSVG;